
import "@glidejs/glide/dist/css/glide.core.min.css";

export default {
  props: {
    steps: {
      type: Array,
      default: () => {
        return [
          {
            img: "web-step-1.png",
            title: "Étude de votre activité",
            text: "D’abord bien connaître votre entreprise et vos objectifs pour vous proposer les offres les plus pertinentes et atteindre la réalisation de votre projet à vitesse grand V.",
            alt: "Objectifs site internet",
            picto: null,
          },
          {
            img: "web-step-2.png",
            title: "Création de votre site web",
            text: "Conception d’une maquette de site internet à l’image de votre activité par nos experts webdesigners.",
            alt: "Création de site internet",
            picto: null,
          },
          // {
          //   img: "web-step-3.png",
          //   title: "Optimisation du référencement",
          //   text: "Création de contenus adaptés à vos clients et à la stratégie de référencement pour attirer toujours plus de prospects qualifiés.",
          //   alt: "Optimisation du référencement SEO",
          //   picto: null,
          // },
          {
            img: "web-step-4.png",
            title: "Hébergement",
            text: "Hébergement (stockage des données) et sécurisation de votre site web sur nos serveurs.",
            alt: "Hébergement de site internet",
            picto: null,
          },
          {
            img: "web-step-5.png",
            title: "Mise en ligne",
            text: "Diffusion de votre site web sur la toile. 3, 2, 1 … Décollage !",
            alt: "Mise en ligne de site internet",
            picto: null,
          },
          {
            img: "web-step-6.png",
            title: "Suivi et accompagnement",
            text: "Maintenance et modifications ponctuelles de vos contenus, pour un site dynamique et toujours à jour.",
            alt: "Statistiques site internet",
            picto: null,
          },
        ];
      },
    },
    title: {
      type: String,
      default: `Votre site web en <span class="text-primary-500 font-clash font-bold">5 étapes</span>`,
    },
    surtitle: {
      type: String,
      default: "La création d'un site web chez Aleo",
    },
    btnActive: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: String,
      default: "lg:mt-[260px]",
    },
    top: {
      type: String,
      default: "top-[-245px]",
    },
  },

  data() {
    return {
      distance: null,
      isDesktop: true,
    };
  },

  mounted() {
    this.watchMedia();

    if (this.isDesktop) {
      this.getDistanceTimeline();
      // const timelineStepped = document.querySelector(".timeline-stepped");
      document.querySelector(".timeline").style.height =
        this.distance + 10 + "px";
      document.querySelector(".timeline-stepped-wrapper").style.height =
        this.distance + 10 + "px";
      // timelineStepped.style.height = this.distance + 10 + "px";
      document.querySelector(".col-1").style.position = "relative";
      setTimeout(() => {
        this.animateTimeline();
      }, 500);
    } else {
      this.initGlide();
    }
  },

  beforeDestroy() {
    this.$ScrollTrigger.getAll().forEach((t) => t.kill());
  },

  methods: {
    getDistanceTimeline() {
      if (this.isDesktop) {
        this.distance =
          document.querySelector(".step-" + this.steps.length).offsetTop -
          document.querySelector(".step-1").offsetTop;
      }
    },

    animateTimeline() {
      this.$gsap.to(".timeline-stepped", {
        scrollTrigger: {
          trigger: ".timeline-stepped",
          endTrigger: ".step-" + this.steps.length,
          scrub: true,
          start: "top 50%",
          end: `bottom 50%`,
        },
        height: this.distance,
      });
    },

    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);
    },

    initGlide() {
      const getGlide = () => import("@glidejs/glide/dist/glide.modular.esm");

      getGlide().then(({ default: Glide, Swipe, Controls }) => {
        const glideSteps = new Glide("#glide-steps", {
          type: "slider",
          perView: 1.2,
          gap: 32,
          rewind: true,
        }).mount({ Swipe, Controls });

        if (window.matchMedia("(min-width: 1024px)").matches) {
          glideSteps.disable();
        } else {
          glideSteps.enable();
        }

        window
          .matchMedia("(min-width: 1024px)")
          .addEventListener("change", (event) => {
            if (event.matches) {
              glideSteps.disable();
              this.isDesktop = true;
            } else {
              glideSteps.enable();
              this.isDesktop = false;
            }
          });
      });
    },
  },
};
